import { createSelector } from 'reselect';

import { isEmpty, get } from 'lodash';

export const getUserFromStore = ({ session }) => session.data.user;

export const getUser = createSelector(getUserFromStore, user =>
  isEmpty(user)
    ? user
    : {
        ...user,
        full_name:
          user.first_name && user.last_name
            ? `${user.first_name} ${user.last_name}`
            : user.username,
      },
);

export const getToken = ({ session }) => session.data.token;

export const getIsLoggedIn = createSelector(
  getUser,
  getToken,
  (user, token) => !isEmpty(user) && token !== '',
);

export const getIsLoading = ({ session }) => session.login.isLoading;

export const getError = ({ session }) => session.login.error;

export const getIsLoadingForgotPassword = ({ session }) =>
  session.forgotPassword.isLoading;

export const getErrorForgotPassword = ({ session }) =>
  session.forgotPassword.error;

export const getIsLoadingResetPassword = ({ session }) =>
  session.resetPassword.isLoading;

export const getErrorResetPassword = ({ session }) =>
  session.resetPassword.error;

export const getIsUpdatingAvatar = ({ session }) =>
  session.updateAvatar.isLoading;

export const getIsUpdatingPassword = ({ session }) =>
  session.updatePassword.isLoading;

export const getUserFullNameDotFormat = createSelector(getUserFromStore, user =>
  get(user, 'first_name') && get(user, 'last_name')
    ? `${user.first_name.charAt(0).toUpperCase()}.${user.last_name
        .charAt(0)
        .toUpperCase()}${user.last_name.substring(1)}`
    : user.username,
);
